import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { guest: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { guest: true },
  },
  {
    path: '/',
    component: () => import('@/components/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: 'zeiterfassung',
        name: 'TimeTracking',
        component: () => import('@/views/TimeTracking.vue'),
      },
      {
        path: 'eintraege',
        name: 'TimeEntries',
        component: () => import('@/views/TimeEntries.vue'),
      },
      {
        path: 'woche',
        name: 'WeekView',
        component: () => import('@/views/WeekView.vue'),
      },
      {
        path: 'monat',
        name: 'MonthView',
        component: () => import('@/views/MonthView.vue'),
      },
      {
        path: 'projekte',
        name: 'Projects',
        component: () => import('@/views/ProjectsView.vue'),
      },
      {
        path: 'profil',
        name: 'Profile',
        component: () => import('@/views/ProfileView.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters['auth/isLoggedIn'];

  if (to.matched.some((r) => r.meta.requiresAuth) && !loggedIn) {
    next({ name: 'Login' });
  } else if (to.meta.guest && loggedIn) {
    next({ name: 'Dashboard' });
  } else {
    next();
  }
});

export default router;
